import React, { useState, useEffect} from "react";
import {
  Input,
  Form,
  Col,
  Row,
  Button,
  Select,
  Collapse,
  InputNumber,
  DatePicker,
} from "antd";
import { CloseOutlined, SearchOutlined } from "@ant-design/icons";
import RequestHandler from "../../util/RequestHandler";
import { odata } from "./Helper";

const CheckPromissoryTableFilter = (props) => {
  const [form] = Form.useForm();

  const [firmSelect, setFirmSelect] = useState({
    data: [],
    loading: false,
  });
  const [monthlyPlanTypeSelect, setMontlyPlanTypeSelect] = useState({
    data: [],
    loading: false,
  });
  const [transactionProcessTypeSelect, setTransactionProcessTypeSelect] = useState({
    data: [],
    loading: false,
  });
  const [currencySelect, setCurrencySelect] = useState({
    data: [],
    loading: true,
  });
  const [ bankDropdown, setbankDropdown] = useState([]);

  useEffect(() => {
    getMonthlyPlanTypes();
    getTransactionProcessTypes();
    getCurrencies();
    getBanks();
  }, [setbankDropdown]);

  useEffect(() => {
    if(props.data){
      form.setFieldsValue(props.data);
    }
  }, [props.data]);

  const onFirmSearch = (value) => {
    if(value.length >= 2){
      setFirmSelect({ data: [], loading: true});
      RequestHandler.get(
        `/Firm?$select=id,firmBranchNumber,name&$filter=${odata.contains(
          "name",
          value
        )} or ${odata.contains("firmBranchNumber", value)}`
      ).then((res) => {
        setFirmSelect({ data: res.value, loading: false });
      });
    } else {
      setFirmSelect({ data: [], loading: false });
    }
  };

  const getMonthlyPlanTypes = () => {
    setMontlyPlanTypeSelect({
      ...monthlyPlanTypeSelect,
      loading: true,
    });
    RequestHandler.get(`/MonthlyPlanType?$select=id,name&$filter=tolower(name) eq 'çek' or tolower(name) eq 'senet'`).then(
      (response) => {
        setMontlyPlanTypeSelect({
          data: response.value,
          loading: false,
        });
      }
    );
  };

  const getTransactionProcessTypes = () => {
    setTransactionProcessTypeSelect({
      ...transactionProcessTypeSelect,
      loading: true,
    });
    RequestHandler.get(`/Types/GetManualTransactionTypes`).then((response) => {
      setTransactionProcessTypeSelect({
        data: response,
        loading: false,
      });
    });
  };

  const getCurrencies = () => {
    setCurrencySelect({
      ...currencySelect,
      loading: true,
    });
    RequestHandler.get(`/Currency/GetFilterCurrency`).then((response) => {
      setCurrencySelect({
        data: response,
        loading: false,
      });
    });
  };

  const getBanks = () => {
    RequestHandler.get(`/Bank`).then(response => {
      setbankDropdown(response.value.filter(x => x.isSupportAccountTransaction === true));
    });
  };

  const onFinish = (values) => {
    {
      let query = "";
    const conditions = [];

    if(values.firmId){
      conditions.push(`firmId eq ${values.firmId}`);
    }

    if(values.monthlyPlanTypeId){
      conditions.push(`monthlyPlanTypeId eq ${values.monthlyPlanTypeId}`);
    }

    if(values.otherTransactionProcessTypeValue){
      conditions.push(`otherTransactionProcessTypeValue eq ${values.otherTransactionProcessTypeValue}`);
    }

    if(values.transactionDateRange){
      const [startDate, endDate] = values.transactionDateRange;
      conditions.push(odata.dateRange("transactionDateValue", startDate, endDate));
    }

    const amountQuery = odata.ConditionalRange("amount", values.amountMin, values.amountMax);
    if(amountQuery) conditions.push(amountQuery);

    if(values.currencyCode){
      conditions.push(`currencyCode eq '${values.currencyCode}'`);
    }

    if(conditions.length !== 0){
      query = conditions.join(" and ");
    }

    if(props.onFinishFilter) props.onFinishFilter(query, values);
    }
  };

  const clearFilter = () => {
    form.resetFields();
    if(props.onClearFilter){
      props.onClearFilter();
    }
  };

  return (
    <Row id="filterArea" style={{ ...props.style }}>
      <Col span={24}>
        <Collapse>
          <Collapse.Panel header="Filtreleme için tıklayınız.">
            <Form
              name="filter"
              form={form}
              initialValues={{
                remember: true,
              }}
              layout="vertical"
              onFinish={onFinish}
            >
              <Row style={{ flexDirection: "row" }}>
                <Col xs={24} md={12} lg={6}>
                  <Form.Item name="firmId" label="Cari :">
                    <Select
                      allowClear
                      showSearch
                      placeholder="En az 2 harf giriniz.."
                      onSearch={onFirmSearch}
                      filterOption={(input, option) =>
                        option.children
                          .toLocaleLowerCase("tr-TR")
                          .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0 ||
                        option.code
                          .toLocaleLowerCase("tr-TR")
                          .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                      }
                      loading={firmSelect.loading}
                    >
                      {firmSelect.data.map((item) => (
                        <Select.Option
                          key={item.id}
                          value={item.id}
                          code={item.firmBranchNumber}
                        >
                          {item.name}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} lg={6}>
                  <Form.Item name="monthlyPlanTypeId" label="İşlem Tipi :">
                    <Select
                      showSearch
                      allowClear
                      placeholder="Tümü"
                      filterOption={(input, option) =>
                        option.props.children
                          .toLocaleLowerCase("tr-TR")
                          .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                      }
                      loading={monthlyPlanTypeSelect.loading}
                    >
                      {monthlyPlanTypeSelect.data.map((item) => (
                        <Select.Option key={item.id} value={item.id}>{item.name}</Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} lg={6}>
                  <Form.Item name="otherTransactionProcessTypeValue" label="İşlem Türü :">
                    <Select
                      allowClear
                      placeholder="Tümü"
                      filterOption={(input, option) =>
                        option.children
                          .toLocaleLowerCase("tr-TR")
                          .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                      }
                      loading={transactionProcessTypeSelect.loading}
                    >
                      {transactionProcessTypeSelect.data.map(({ key, value }) => (
                        <Select.Option key={key} value={key}>
                          {value}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} lg={6}>
                  <Form.Item name="transactionDateRange" label="Tarih :">
                    <DatePicker.RangePicker
                      format="DD.MM.YYYY"
                      style={{ width: "100%" }}
                    />
                  </Form.Item>
                </Col>

                <Col xs={24} md={12} lg={6}>
                  <Form.Item
                    style={{ marginBottom: 0 }}
                    label="Tutar :"
                  >
                    <Input.Group>
                      <Row gutter={1} style={{ flexDirection: "row" }}>
                        <Col span={12}>
                          <Form.Item name="amountMin">
                            <InputNumber style={{ width: "100%" }} precision={2} />
                          </Form.Item>
                        </Col>
                        <Col span={12}>
                          <Form.Item name="amountMax">
                            <InputNumber style={{ width: "100%" }} precision={2} />
                          </Form.Item>
                        </Col>
                      </Row>
                    </Input.Group>
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} lg={6}>
                  <Form.Item name="currencyCode" label="Para Birimi :">
                    <Select
                      allowClear
                      showSearch
                      placeholder="Tümü"
                      filterOption={(input, option) =>
                        option.children
                          .toLocaleLowerCase("tr-TR")
                          .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                      }
                      loading={currencySelect.loading}
                    >
                      {currencySelect.data.map(({ text, value }) => (
                        <Select.Option key={text} value={text}>
                          {value}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
              <Row style={{ flexDirection: "row" }}>
                <Col span={24} style={{ textAlign: "right" }}>
                  <Button
                    danger
                    size="small"
                    icon={<CloseOutlined />}
                    onClick={() => clearFilter()}
                  >
                    Sıfırla
                  </Button>
                  <Button
                    type="primary"
                    size="small"
                    icon={<SearchOutlined />}
                    style={{ color: "#40a9ff", borderColor: "#40a9ff" }}
                    htmlType="submit"
                  >
                    Filtrele
                  </Button>
                </Col>
              </Row>
            </Form>
          </Collapse.Panel>
        </Collapse>
      </Col>
    </Row>
  )
}

export default CheckPromissoryTableFilter;
